import { Address } from './address.model';

export class Offer {

  constructor(
    public id: string,
    public uid: string,
    public title: string,
    public short_title: string,
    public cover: string,
    public description: string,
    public oFor: string,
    public oType: string,
    public oUploader: string,
    public imgsUrl: string[],
    public price: {
      value: number,
      currency: string
    },
    public date: any,
    public status: {
      value: boolean,
      expired_date: any
    },
    public views: number,
    public coordinates: any,
    public address: Address,
    public isSpecial: {
      value: boolean,
      expired_date: any,
      order_id?: string
    },
    public createrForId?: string,
    public draw?: any,
    public details?: any,
    public g?: any,
    public distance?: number,
  ) {}

}
